import { Box, Typography } from '@mui/material';
import React from 'react';

import Logo from '../../../images/logo/logo_mini.svg';
import LogoText from '../../../images/logo/logo_secondary.svg';

const PremiumOptimizationPageHeader: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
                pt: 1,
                backgroundColor: '#515151',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '70%',
                    gap: 1,
                }}
            >
                <img data-testid="logo-image" src={Logo} style={{ height: '100px', filter: 'grayscale(1)' }} />
                <img data-testid="logo-text" src={LogoText} style={{ height: '60px', filter: 'grayscale(1)' }} />
            </Box>
            <Box
                sx={{
                    width: '40%',
                    color: '#b7b7b7',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'space-evenly',
                    py: 2,
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Welcome to your daily dashboard
                </Typography>
                <Typography variant="body1">
                    Here, we present the key tasks for the day, ensuring you get the best out of your fleet.
                </Typography>
                <Typography variant="body1">
                    Below, you&apos;ll find insights into potential issues affecting your safety, and tailored
                    recommendations to address them effectively.
                </Typography>
            </Box>
        </Box>
    );
};

export default PremiumOptimizationPageHeader;
